import { render } from "./IconArrow.vue?vue&type=template&id=db29067e"
const script = {}
script.render = render

export default script